import type { CSearchTranslations } from "./pl";

const GROUP_LABELS: Record<string, string> = {
  c_news: "News",
  c_blog: "Blog",
  c_shop: "Shop",
  c_faq: "FAQ",
  c_events_calendar: "Events",
  c_photo_gallery: "Photo galleries",
  c_video_gallery_outer: "Video galleries",
  c_files_to_download: "Downloads",
  c_job_offers: "Job offers",
  c_advertisements: "Classifieds",
  c_descriptive_page: "Pages",
  c_procedures: "Procedures",
  c_polls: "Polls",
  c_browser_press_online: "Online press",
  c_shop_delivery_points: "Pickup points",
};

export const en: CSearchTranslations = {
  emptyData: "No data to display.",
  inputLabel: "Search",
  inputPlaceholder: "Tell us what you are looking for",
  submit: "Search",
  resultsFor: "Results for",
  noQuery: "Enter a phrase to search.",
  noResults: "No results for the given phrase.",
  wrongWords: "Skipped too-short words (min. 3 chars):",
  catalogsTitle: "Pages",
  resultsCount: (n) => `(found: ${n})`,
  groupLabel: (symbol) => GROUP_LABELS[symbol] ?? symbol,
};
